import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../auth/services/auth.service';
import 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';
import { GlobalAdjustments } from '../models/global-adjustments.model';
import { GlobalSettings } from '../models/global-settings.model';
import { GlobalChanges } from '../models/global-changes.model';
import { SettingsService } from '../../settings/services/settings.service';
import { UserAddons } from '../models/user-addons.model';
import { PermissionService } from '../../auth/services/permission.service';
import { EventsService } from '../../events/services/events.service';
import { Validators } from '@angular/forms';

@Injectable()
export class GlobalSettingsService {
    appSettings = this.settingsService.Get();
    userAddons: UserAddons;

    onGlobalSettingsUpdated = new Subject<GlobalSettings>();
    onUserAddonsUpdated = new Subject<UserAddons>();
    private globalSettings: GlobalSettings;
    private globalChanges: GlobalChanges;
    private newAltDerivative = "Not Changed";
    private apiUrl = this.appSettings.apiUrl;
    private createNew = false;
    private changedFields = new Array<string>();

  constructor(
    private httpService:HttpClient,
    private authService: AuthService,
    private settingsService: SettingsService,
    private permissionService: PermissionService,
    private eventsService: EventsService
  ) {
    this.authService.onLoggedIn.subscribe(response => {
      if (response) {
        this.globalChanges = new GlobalChanges();
        this.getUserAddonsFromService();
        this.loadGlobalSettings();
      }
    });
    this.authService.getUserLoginState();
  }

    private getUserAddonsFromService() {
        this.permissionService.getUserAddons()
            .map((r: UserAddons) => r)
            .subscribe(
                (response) => {
                    this.userAddons = response;
                    this.onUserAddonsUpdated.next(this.userAddons);
                },
                (error) => console.log(error)
            );
    }

    public get hasChanges() {
        return this.globalChanges.globalSettingsChanged;
    }

  public get getSettings() {
    return this.globalSettings;
  }

  getGlobalAdjustments() {
    if (this.globalSettings != null) {
      this.onGlobalSettingsUpdated.next(this.globalSettings);
    }
  }

    getUserAddons() {
        if (this.userAddons != null) {
            this.onUserAddonsUpdated.next(this.userAddons);
        }
    }

    recordChangedField(field: string) {
      if(!this.changedFields.find(v => v===field))
        {
          this.changedFields.push(field);
        }
    }

    recordAltDerivativeChange(newValue: string)
    {
        this.newAltDerivative = newValue;
    }

    updateGlobalAdjustments(settings: GlobalSettings) {
        this.globalSettings = settings;
        this.setVATRateToPositiveNumber();
        this.setMileageTolerancesToPositiveNumber();
        this.setNumberOfDaysToBelowSixhundred();
        this.globalChanges.globalSettingsChanged = true;
    }

    saveGlobalAdjustments() {
    if (this.authService.getAuthorisationHeader() == null) {
      console.log('Failed to save Global Adjustments');
        return;
    }

    if(this.newAltDerivative != 'Not Changed')
      {
        this.eventsService.recordAlternativeDerivativeSettingChangedEvent(this.newAltDerivative);
      }

    this.eventsService.recordGlobalSettingsChangedEvent(this.changedFields);
    this.changedFields = new Array<string>();

    this.httpService
      .put(this.apiUrl + '/settings', this.globalSettings, { headers: this.authService.getAuthorisationHeader() })
      .subscribe(
        response => this.loadGlobalSettings(),
        error => { 
          this.loadGlobalSettings();
          console.log(error)}
      );
  }

  loadSavedSettings() {
    this.loadGlobalSettings();
  }

  private loadGlobalSettings() {
    this.createNew = false;
    if (this.authService.getAuthorisationHeader() == null) {
        return;
    }

    this.httpService
      .get(this.apiUrl + '/settings', { headers: this.authService.getAuthorisationHeader() })
      .map((response) => response as GlobalSettings)
      .subscribe(response => {
        this.globalSettings = response;
        if (
          response.adjustments !== undefined &&
          response.adjustments !== null
        ) {
          this.globalChanges.globalSettingsChanged = false;
        } else {
          this.createNew = true;
          this.globalSettings.adjustments = new GlobalAdjustments();
          this.globalChanges.globalSettingsChanged = true;
        }
        this.onGlobalSettingsUpdated.next(this.globalSettings);
      });
  }

  private setVATRateToPositiveNumber() {
    this.globalSettings.adjustments.vatRate = Math.abs(
      this.globalSettings.adjustments.vatRate
    );
  }

  private setMileageTolerancesToPositiveNumber() {
    this.globalSettings.reportSettings.percentBelowContractMileage = Math.abs(
      this.globalSettings.reportSettings.percentBelowContractMileage
    );
    this.globalSettings.reportSettings.percentOverContractMileage = Math.abs(
      this.globalSettings.reportSettings.percentOverContractMileage
    );
  }

  private setNumberOfDaysToBelowSixhundred() {
    this.globalSettings.reportSettings.daysAfterDiscontinuedDate = this.globalSettings.reportSettings.daysAfterDiscontinuedDate > 600 ? 600 : this.globalSettings.reportSettings.daysAfterDiscontinuedDate;
    this.globalSettings.reportSettings.daysBeforeIntroducedDate = this.globalSettings.reportSettings.daysBeforeIntroducedDate > 600 ? 600 : this.globalSettings.reportSettings.daysBeforeIntroducedDate;  
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/services/global-settings.service.ts